import { LucideIcon } from 'lucide-react';

interface IconActionButtonProps {
  icon: LucideIcon;
  label: string;
  onClick?: () => void;
  href?: string;
  danger?: boolean;
}

/**
 * The shared icon-action-tile pattern for a detail page's action
 * bar (View/Print/Edit/Delete-style actions) - one real component
 * so every page renders this identically, rather than each page
 * inventing its own icon+label markup. Renders as a real link when
 * href is given (e.g. a PDF download), a button otherwise.
 */
export function IconActionButton({ icon: Icon, label, onClick, href, danger }: IconActionButtonProps) {
  const tileClass = danger ? 'icon-action-tile icon-action-tile-danger' : 'icon-action-tile';

  if (href) {
    return (
      <a className="icon-action" href={href} target="_blank" rel="noreferrer">
        <span className={tileClass}><Icon size={20} /></span>
        <span className="icon-action-label">{label}</span>
      </a>
    );
  }

  return (
    <button type="button" className="icon-action" onClick={onClick}>
      <span className={tileClass}><Icon size={20} /></span>
      <span className="icon-action-label">{label}</span>
    </button>
  );
}
